export interface PriceTagProps {
  cents: number;
  compareAtCents?: number;
  currency?: string;
  className?: string;
}

export function formatCents(cents: number, currency = "PKR") {
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency,
    maximumFractionDigits: 0
  }).format(cents / 100);
}

// Single source of truth for "X% OFF" — anywhere a discount badge is shown
// should derive it from real basePrice/compareAtPrice, never a hardcoded
// number. Returns null when there's no genuine discount to show.
export function getDiscountPercent(basePrice: number, compareAtPrice?: number | null): number | null {
  return compareAtPrice && compareAtPrice > basePrice ? Math.round((1 - basePrice / compareAtPrice) * 100) : null;
}

export function PriceTag({ cents, compareAtCents, currency = "PKR", className }: PriceTagProps) {
  return (
    <span className={className}>
      <span className="font-semibold text-ink">{formatCents(cents, currency)}</span>
      {compareAtCents && compareAtCents > cents && (
        <span className="ml-2 text-ink-muted line-through">{formatCents(compareAtCents, currency)}</span>
      )}
    </span>
  );
}
